import DeleteButton from "./Delete";

export default {
    button: DeleteButton,
    name: "delete",
};
